<template>
  <section v-if="templates" class="grid">
    <TemplateCard :data="templates" name="Plantilla contactos" type="contacts" />
    <TemplateCard :data="templates" name="Plantilla productos" type="product" />
  </section>
</template>

<script>
import { defineComponent } from "vue";

import TemplateCard from "@/app/imports/components/cards/TemplateCard.vue";

export default defineComponent({
  components: {
    TemplateCard,
  },
  computed: {
    templates() {
      return this.$store.getters["getTemplatesFromPortfolio"];
    },
  },
});
</script>

<style lang="sass" scoped>


.grid
  padding: 12px 0
  display: flex
</style>
